import React from "react";

const DateDescriptionType = (props) => {
  
  let className = "text-area-type form-group pt-6 pl-3";
  if (props.showInDocUpload) {
    className = "text-area-type form-group pt-3";
  }
  if (props.viewOnly) {
    className += " view-only";
  }
  return !props.viewOnly ? (
    <div className={className}>
      <label className="bold" htmlFor={props.field.fieldId}>
        {props.field.fieldLabel}
        {props.field.fieldRequired && !props.viewOnly && "*"}
      </label>
      <textarea
        className="form-control"
        id={props.field.fieldId}
        value={
          props.viewOnly && !props.field.fieldValue
            ? "-"
            : props.field.fieldValue
        }
        onChange={props.fieldValueChangeHandler}
        maxLength="300"
        rows="2"
        placeholder={props.field.fieldPlaceHolder}
      ></textarea>
    </div> 
  ) 
  : (
    null
  )
};

export default DateDescriptionType;
